/* SK Product Maridajes - add to cart AJAX con feedback visual (check verde) */
(function () {
  'use strict';

  /* Handler delegado: 1 solo listener en el document, captura clicks en cualquier boton maridajes */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sk-product-maridajes__card-cart');
    if (!btn) return;

    var form = btn.closest('.sk-product-maridajes__card-form');
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.classList.contains('sk-product-maridajes__card-cart--loading')) return;
    btn.classList.add('sk-product-maridajes__card-cart--loading');

    var formData = new FormData(form);

    /* Pedir sections del drawer para re-renderizar el carrito lateral */
    var cartItemsComp = document.querySelector('cart-items-component[data-section-id]');
    var sectionId = cartItemsComp ? cartItemsComp.dataset.sectionId : '';
    if (sectionId) formData.append('sections', sectionId);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.classList.remove('sk-product-maridajes__card-cart--loading');

        if (data.status) {
          console.error('Error al anadir maridaje:', data.description || data.message);
          return;
        }

        /* Check verde durante 1.5s */
        btn.classList.add('sk-product-maridajes__card-cart--added');
        setTimeout(function () {
          btn.classList.remove('sk-product-maridajes__card-cart--added');
        }, 1500);

        /* Actualizar contador + dispatch cart:update con sections + abrir drawer */
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          var counters = document.querySelectorAll('[data-cart-count]');
          for (var c = 0; c < counters.length; c++) counters[c].textContent = cart.item_count;

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, data: { sections: data.sections || {}, itemCount: cart.item_count } },
          }));

          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && drawer.showDialog) drawer.showDialog();
        });
      })
      .catch(function (err) {
        console.error('Error fetch cart/add.js:', err);
        btn.classList.remove('sk-product-maridajes__card-cart--loading');
      });
  });
})();
